import { render, staticRenderFns } from "./modalContingency.vue?vue&type=template&id=40f2719b&scoped=true&"
import script from "./modalContingency.vue?vue&type=script&lang=js&"
export * from "./modalContingency.vue?vue&type=script&lang=js&"
import style0 from "./modalContingency.vue?vue&type=style&index=0&id=40f2719b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2719b",
  null
  
)

export default component.exports